import React from 'react'
import { useTranslation } from 'react-i18next'
import { ModalProps, Form } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import Button from '@components/ui/Button'
import Hr from '@components/ui/Hr'
import Modal from '@components/ui/Modal/Modal'
import { Select } from '@components/ui/Select'
import localStorageUtil from '@/utils/localstorage'

const EmissionStandardModal = (props: ModalProps) => {
  const { t } = useTranslation()
  const [standard, setStandard] = React.useState()

  const handleSubmit = (obj: any) => {
    localStorageUtil.set('menu_std', obj.standard)
    props.onOk && props.onOk(obj.standard)
  }

  React.useEffect(() => {
    const std = localStorageUtil.get('menu_std')
    setStandard(std || 'iso')
  }, [])

  return (
    <Modal
      {...props}
      maskClosable
      footer={null}
      closeIcon={
        <CloseCircleOutlined onClick={props.onCancel} style={{ fontSize: '22px', color: '#000' }} />
      }
      title={
        <div>
          <h2>{t('menu:Select Emission Std')}</h2>
          <Hr />
        </div>
      }>
      <Form onFinish={handleSubmit}>
        <Form.Item name="standard" label={t('menu:Emission Std')} initialValue={standard}>
          <Select className="w-180">
            <Select.Option key="iso" value="iso">
              ISO 14064-1:2018
            </Select.Option>
            <Select.Option key="ghg" value="ghg">
              GHG Protocol
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item className="text-right">
          <Button htmlType="submit" color="primary">
            {t('common:Submit')}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default EmissionStandardModal
